var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',[_c('b-row',[_c('b-table',{attrs:{"items":_vm.items,"fields":_vm.fields}})],1),_c('b-row',[_c('b-col',[_c('b-button',{on:{"click":_vm.toggleEdit}},[_vm._v("Edytuj raport")]),_c('b-button',[_vm._v("Wyślij")])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }